import { BaseViewStore } from 'core/stores';
import { makeObservable, observable } from 'mobx';
import _ from 'lodash';
import { runInAction } from 'mobx';
import { action } from 'mobx';
import PickingBatchStore from './PickingBatchStore';

class PickingBatchInfoViewStore extends BaseViewStore {
	@observable data = null;

	constructor(rootStore, { modalParams }) {
		super(rootStore);
		makeObservable(this);
		this.pickingBatchId = modalParams.data.pickingBatchId;
		this.pickingBatchStore = new PickingBatchStore(rootStore);
		this.fetchData();
	}

	@action.bound
	async fetchData() {
		this.loading = true;
		try {
			const errorResponse = await this.pickingBatchStore.getPickingBatchInfo(this.pickingBatchId);
			runInAction(() => {
				this.data = errorResponse;
				this.loading = false;
			});
		} catch (err) {
			runInAction(() => {
				this.loading = false;
			});
			this.rootStore.notificationStore.error(['PICKINGBatchInfoVIEW.PICKINGBatchInfoFETCHFAIL', { id: this.pickingBatchId }]);
		}
	}
}

export default PickingBatchInfoViewStore;
